import React from 'react';
import UserDataType from '../components/UserDataType/UserDataType';
import AuthenticatedLayout from '../components/AuthenticatedLayout';

export default function CaseUserDataType() {
    return (
        <AuthenticatedLayout title="Dados de Usuário">
            <UserDataType />
        </AuthenticatedLayout>
    );
}
